import React from "react";
import styled from "@emotion/styled";
import ArrowRightIcon from "@assets/icons/arrow-right.svg";
import { TertiaryButton } from "@ui/components/buttons/tertiary-button";

interface ArrowButtonProps {
	label: string;
	onClick: (() => void) | ((event: React.MouseEvent<HTMLDivElement>) => void);
}

export const ArrowButton: React.FC<ArrowButtonProps> = ({ label, onClick }) => (
	<Container>
		<TertiaryButton onClick={onClick} label={label} icon={<ArrowRightIcon width={24} height={24} />} />
	</Container>
);

const Container = styled.div`
	margin-top: 24px;
`;
